import optimizeText from './optimize_text/en'
export default {
  ...optimizeText
}
